import client from './client';

// export const listSettings = () => client.get('/v1/user/settings/');

export const saveSettings = (settings) => client.put('/v1/user/settings/', settings);

export const migrationInfo = () => client.get('v1/user/migration/');
